import {
    ADD_OR_UPDATE_NEW_COUNTRY_SUCCESS,
    ADD_OR_UPDATE_NEW_COUNTRY_FAILED,
    LOADING_ADD_OR_UPDATE_NEW_COUNTRY,
    NETWORK_ERROR_ADD_OR_UPDATE_NEW_COUNTRY
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminAddOrUpdateNewCountryAction =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ADD_OR_UPDATE_NEW_COUNTRY });
        await adminServices
            .post("addNewCountry", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: ADD_OR_UPDATE_NEW_COUNTRY_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: ADD_OR_UPDATE_NEW_COUNTRY_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_ADD_OR_UPDATE_NEW_COUNTRY,
                    payload: err
                });
            });
    };

export { adminAddOrUpdateNewCountryAction };
